import { Form, Formik } from 'formik'
import Header from 'components/headers/bulletins'
import Switch from 'react-switch'
import { useState } from 'react'
import LeftIcon from 'assets/images/sidebar/chevron_left.svg'
import ManagerAccountModal from 'components/modals/managerAccount'
import MyWalletModals from 'components/modals/myWallets'
import { BankConvertor } from 'utilities/helper/banksConvertor'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import { toggleManager } from 'store/redux/moneyPoolBox'
import LastAddBoxModal from 'components/modals/lastAddBox'
import { toggleSupportModal } from 'store/redux/sidebar'
import SupportModal from 'components/modals/supportModal'
import posthog from 'posthog-js'
import DotsWhiteLoading from 'components/loadings/dotsWhiteLoading'
import useSetCustomImage from 'components/modals/lastAddBox/hooks/useSetCustomImage'
import useSetAddFirstBox from 'components/modals/lastAddBox/hooks/useSetAddFirstBox'
import useIsTrancparency from 'components/modals/lastAddBox/hooks/useIsTrancparency'

// «ثبت سوابق مدیر» is stage 0 of LastAddBoxModal: create, then the records.
const WITH_MANAGER_HISTORY = 0

export default function Manage() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    // «انتقال صندوق به همیان» already answered the modal's question, so the
    // button says what comes next and goes there — Android
    // `AddMpManagementInfoFragment`: `manager_records`, then the records page.
    const isTransfer = !!store?.isTransfer
    const { CustomImageMutate, isLoadingImage } =
        useSetCustomImage(WITH_MANAGER_HISTORY)
    const { mutate: createFund, isLoading: isCreatingFund } = useSetAddFirstBox(
        CustomImageMutate,
        WITH_MANAGER_HISTORY
    )
    // A custom image is a second request after the fund exists; a tap in
    // between would create the fund twice.
    const isCreating = isCreatingFund || isLoadingImage
    const { handlePayload } = useIsTrancparency()
    const [isOpenLastModal, setIsOpenLastModal] = useState<boolean>(false)
    const [isOpenManagerAccountModal, setIsOpenManagerAccountModal] =
        useState<boolean>(false)
    const [isOpenMyWalletModal, setIsOpenMyWalletModal] =
        useState<boolean>(false)
    const [checked, setChecked] = useState<{ [key: string]: boolean }>({
        isManagerAccount:
            store?.isManagerAccount !== undefined
                ? store?.isManagerAccount
                : false,
        bankPortal: false,
        help: store?.help !== undefined ? store?.help : false,
    })
    const [selectedCard, setSelectedCard] = useState<
        undefined | IBankCardsResult
    >(store?.bankAccount !== undefined ? store?.bankAccount : undefined)
    const [isOnceOpenCard, setIsOnceOpenCard] = useState<boolean>(
        store?.bankAccount !== undefined ? true : false
    )
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const handleChangeChecked = (value: string) => {
        const newChecked = { ...checked }
        newChecked[value] = !newChecked[value]
        setChecked(newChecked)
        if (value === 'isManagerAccount' && newChecked.isManagerAccount) {
            setIsOpenManagerAccountModal(true)
        }
    }

    return (
        <>
            <Formik initialValues={{ name: '' }} onSubmit={async () => {}}>
                {({ submitForm, values, handleChange, errors, touched }) => (
                    <Form>
                        <div className="  flex flex-col bg-main-bg h-full">
                            <div className=" grow-0">
                                <Header title="تنظیمات صندوق" />
                            </div>
                            <div className=" grow px-2">
                                <div className=" bg-white py-3 px-4 my-2 ">
                                    <p className=" text-center text-[#858585]">
                                        مدیریت حساب
                                    </p>
                                    <div className=" w-full flex justify-between my-2">
                                        <p className=" text-xl">
                                            اتصال به حساب مدیر
                                        </p>
                                        <Switch
                                            onChange={() =>
                                                handleChangeChecked(
                                                    'isManagerAccount'
                                                )
                                            }
                                            checked={checked.isManagerAccount}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                    <p className=" my-3">
                                        با فعال کردن این گزینه پرداختی‌های اعضا
                                        به حساب بانکی مدیر صندوق واریز می‌شود؛
                                        با خاموش نگه داشتن این گزینه موجودی
                                        صندوق نزد همیان نگه‌داری خواهد شد.
                                    </p>
                                    {selectedCard &&
                                        isOnceOpenCard &&
                                        checked.isManagerAccount && (
                                            <div
                                                className=" bg-[#EFF7E9] p-4 rounded-xl"
                                                onClick={() =>
                                                    setIsOpenMyWalletModal(true)
                                                }
                                            >
                                                <div className=" flex items-center">
                                                    <img
                                                        src={
                                                            BankConvertor[
                                                                selectedCard
                                                                    .bank_unique_code
                                                            ]
                                                        }
                                                        alt="bank"
                                                        className=" w-14 h-14"
                                                    />
                                                    <p>
                                                        بانک{' '}
                                                        {selectedCard.bank_name}
                                                    </p>
                                                </div>
                                                <div className=" my-1">
                                                    {
                                                        selectedCard.owner_first_name
                                                    }{' '}
                                                    {
                                                        selectedCard.owner_last_name
                                                    }
                                                </div>
                                                <div className=" my-1">
                                                    {selectedCard.iban &&
                                                    selectedCard.iban.length >
                                                        0 ? (
                                                        <p>
                                                            {selectedCard.iban}
                                                        </p>
                                                    ) : (
                                                        selectedCard.card_number &&
                                                        selectedCard.card_number
                                                            .length > 0 && (
                                                            <p>
                                                                {
                                                                    selectedCard.card_number
                                                                }
                                                            </p>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    <hr className=" my-4" />
                                    <div className=" w-full flex justify-between my-2">
                                        <p className=" text-xl">
                                            پرداخت از طریق درگاه بانکی
                                        </p>
                                        <Switch
                                            onChange={() =>
                                                toast.error(
                                                    'بعد از ساخت صندوق، از طریق تنظیمات می توانید پرداخت از طریق درگاه بانکی را فعال کنید'
                                                )
                                            }
                                            checked={checked.bankPortal}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                    <p className=" my-3">
                                        با فعال کردن این گزینه اعضای صندوق
                                        می‌توانند پرداخت حق‌عضویت و اقساطشان را
                                        به کمک درگاه بانکی، از طریق اپ و لینک
                                        پرداخت اختصاصی وب انجام دهند.
                                    </p>
                                </div>
                                <div className=" bg-white py-3 px-4 my-2 ">
                                    <p className=" text-center text-[#858585]">
                                        سایر تنظیمات
                                    </p>
                                    <div className=" w-full flex justify-between my-2">
                                        <p className=" text-xl">
                                            راهنمایی همیان
                                        </p>
                                        <Switch
                                            onChange={() =>
                                                handleChangeChecked('help')
                                            }
                                            checked={checked.help}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                    <p className=" my-3">
                                        با فعال کردن این گزینه یک راهنما به صورت
                                        گام‌به‌گام شما را برای رساندن سرمایه
                                        صندوقتان به ۳۰ میلیون تومان در یک سال
                                        آینده راهنمایی می‌کند.
                                    </p>
                                    <hr className=" my-4" />
                                    <div
                                        className=" w-full flex justify-between my-2 items-center"
                                        onClick={() =>
                                            navigate('/add-box/transparency')
                                        }
                                    >
                                        <p className=" text-xl">نمایش اطلاعات صندوق</p>
                                        <img src={LeftIcon} alt="left_icon" />
                                    </div>
                                    <p className=" my-3 text-[#858585]">
                                        مدیریت و تنظیم نمایش داده‌های صندوق به اعضا
                                    </p>
                                    <hr className=" my-4" />
                                    <div
                                        className=" w-full flex justify-between my-2 items-center"
                                        onClick={() =>
                                            navigate('/add-box/send-message')
                                        }
                                    >
                                        <p className=" text-xl">
                                            پیام‌های اطلاع‌رسانی صندوق
                                        </p>
                                        <img src={LeftIcon} alt="left_icon" />
                                    </div>
                                    <p className=" my-3 text-[#858585]">
                                        مدیریت ارسال پیام‌های اطلاع‌رسانی به اعضا
                                    </p>
                                </div>
                            </div>
                            <div className=" grow-0">
                                <div className=" text-center my-4">
                                    <p>نیاز به راهنمایی دارید؟</p>
                                    <p
                                        className=" text-[#808080] underline"
                                        onClick={() =>
                                            dispatch(
                                                toggleSupportModal({
                                                    isOpenSupportModal: true,
                                                })
                                            )
                                        }
                                    >
                                        با مشاور همیان تماس بگیرید
                                    </p>
                                </div>
                                <div className=" bg-white py-4 px-4">
                                    <button
                                        className=" w-full bg-green-1 rounded-2xl text-white py-3"
                                        onClick={() => {
                                            posthog.capture(
                                                'fund_create_step_completed',
                                                {
                                                    step_name: 'manage',
                                                    step_index: 3,
                                                    is_manager_account_connected:
                                                        (checked as any)
                                                            ?.isManagerAccount,
                                                    help_enabled: (
                                                        checked as any
                                                    )?.help,
                                                    is_transfer: isTransfer,
                                                }
                                            )
                                            dispatch(
                                                toggleManager({
                                                    isManagerAccount:
                                                        checked.isManagerAccount,
                                                    help: checked.help,
                                                    bankAccount: selectedCard,
                                                })
                                            )
                                            if (isTransfer) {
                                                // `handlePayload` reads the
                                                // store from this render,
                                                // before `toggleManager`
                                                // lands — pass «کمک همیان»
                                                // from the switch itself.
                                                createFund({
                                                    ...handlePayload(),
                                                    made_by_kuching:
                                                        !!checked.help,
                                                    is_transfer_box: true,
                                                })
                                            } else {
                                                setIsOpenLastModal(true)
                                            }
                                        }}
                                        disabled={isCreating}
                                    >
                                        {isCreating ? (
                                            <DotsWhiteLoading />
                                        ) : isTransfer ? (
                                            'ثبت سوابق مدیر'
                                        ) : (
                                            'ایجاد صندوق'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <ManagerAccountModal
                show={isOpenManagerAccountModal}
                onHide={() => setIsOpenManagerAccountModal(false)}
                setChecked={setChecked}
                checked={checked}
                setIsOpenMyWalletModal={setIsOpenMyWalletModal}
                setIsOnceOpenCard={setIsOnceOpenCard}
            />
            <MyWalletModals
                show={isOpenMyWalletModal}
                onHide={() => setIsOpenMyWalletModal(false)}
                setSelectedCard={setSelectedCard}
                selectedCard={selectedCard}
            />
            <LastAddBoxModal
                show={isOpenLastModal}
                onHide={() => setIsOpenLastModal(false)}
            />
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
